import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import CustomSelect from "~components/CustomSelect";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import SelectNationality from "~components/SelectNationality";
import SelectPersonGender from "~components/SelectPersonGender";
import { RoleStatuses } from "~enums/roleStatuses";
import styles from "./AddPersonRolesModalFilters.module.css";

type Props = {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setNationality: Dispatch<SetStateAction<string | undefined>>;
  setGender: Dispatch<SetStateAction<string | undefined>>;
  setStatus: Dispatch<SetStateAction<RoleStatuses | undefined>>;
  disabled?: boolean;
  resetPagination: () => void;
};

export const AddPersonToRosterFilters = ({
  setGender,
  setNationality,
  searchValue,
  setSearchValue,
  setStatus,
  disabled = false,
  resetPagination,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <SelectNationality
        onChange={(value) => {
          resetPagination();
          setNationality(value as string | undefined);
        }}
        className={styles.select}
        disabled={disabled}
      />
      <SelectPersonGender
        onChange={(value) => {
          resetPagination();
          setGender(value as string | undefined);
        }}
        className={styles.select}
        disabled={disabled}
      />
      <CustomSelect
        onChange={(value) => {
          resetPagination();
          setStatus(value as RoleStatuses | undefined);
        }}
        options={[RoleStatuses.Active, RoleStatuses.Inactive, RoleStatuses.Pending, RoleStatuses.Deceased, RoleStatuses.Unregistered].map(
          (status) => ({
            label: formatMessage({ id: `roleStatus.${status}` }),
            value: status,
          }),
        )}
        placeholder={formatMessage({ id: "status" })}
        allowClear
        className={styles.select}
        disabled={disabled}
      />
      <SearchFilter
        initial={searchValue}
        searchValue={searchValue}
        doSearch={(value) => {
          resetPagination();
          setSearchValue(value);
        }}
        placeholderIntlKey="search.two.letters"
      />
    </>
  );
};

export default AddPersonToRosterFilters;
